import Group from "../Entities/Group";
import * as Yup from "yup";
import CrudApi from "@serie3/common/api/crudApi";
import GroupConfig from "../Resources/Endpoints";
import listHandler from "../../../Domain/listHandler";

const createGroupForm = (
  groupList = null,
  setGroupList = null,
  setGroupName = null,
  setGroup = null
) => {
  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
  });

  const onSubmit = async (values) => {
    const originalValues = { ...values };

    const editFunction = async (values, originalValues) => {
      let payload = JSON.stringify(values, null, 2);
      const response = await CrudApi.edit(GroupConfig.endpoints.edit, payload);

      let originalPayload = JSON.stringify(originalValues, null, 2);
      listHandler.updateList(
        response,
        originalPayload,
        groupList,
        setGroupList
      );
      setGroupName(values.name);
    };

    if (values.id > 0) {
      editFunction(values, originalValues);
    } else {
      let payload = JSON.stringify(values, null, 2);
      const response = await CrudApi.createNew(
        GroupConfig.endpoints.new,
        payload
      );
      if (response.status === 200) {
        setGroupList && setGroupList((prev) => [...groupList, response.data]);
        setGroupName && setGroupName(response.data.name);
        setGroup && setGroup(response.data);
      }
    }
  };

  return {
    initialValues: Group,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      onSubmit(values);
    },
  };
};

const setEditData = (editData) => {
  let Group = {
    id: editData.id,
    name: editData.name,
  };

  return Group;
};

export default { createGroupForm, setEditData };
